import { useEffect, useRef } from "react";

export default function PdfViewerComponent(props) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    let PSPDFKit, instance;

    (async function () {
      PSPDFKit = await import("pspdfkit");

      // Unload any previous instance
      PSPDFKit.unload(container);

      try {
        const response = await fetch(props.document);
        if (!response.ok) {
          throw new Error(
            `Failed to fetch the document: ${response.statusText}`
          );
        }
        const fileArrayBuffer = await response.arrayBuffer();

        instance = await PSPDFKit.load({
          container,
          document: fileArrayBuffer,
          baseUrl: process.env.REACT_APP_Location + "/",
        });
      } catch (error) {
        console.error("Error loading PDF document:", error);
      }
    })();

    return () => PSPDFKit && PSPDFKit.unload(container);
  }, [props.document]);

  return <div ref={containerRef} style={{ width: "100%", height: "100vh" }} />;
}
